export const USER_MAIL = 'USER_MAIL';
export const USER_MOB = 'USER_MOB';
export const USER_CURRENT_PROFILE = 'userCurrentProfile';
export const AGGREGATED_USER_DETAILS = 'AGGREGATED_USER_DETAILS';
export const ID = 'ID';
export const IS_CONSUMPTION_PAYMENT_JOURNEY = 'IsConsumptionPaymentJourney';
export const CONSUMPTION_PAYMENT_JOURNEY_PATH = 'ConsumptionPaymentJourneyPath';
export const RETAIN_CONSUMPTION_JOURNEY_PATH = 'retainConsumptionJourneyPath';
export const REDIRECT_URL_TO_CONSUMPTION = 'REDIRECT_URL_TO_CONSUMPTION';